export const nzUserFilesToSign = (result) => {
  return result.map(file => ({
    fileId: file.id || '',
    name: file.name || '',
    path: file.relativePath || '',
    description: file.description || '',
    isSigned: file.isSigned,
    url: file.url || ''
  }))
}
